<template>
  <router-view />
</template>

<style>
@import url("https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;800&display=swap");
</style>
